import "./App.css";
import CodeInterface from "../components/CodeInterface/CodeInterface.jsx";

function App() {
  return (
    <>
      <CodeInterface />
    </>
  );
}

export default App;
